{
  "theme": {
    "dark": "Thème sombre",
    "main": "Thème principal"
  },
  "projectCustomisation": {
    "projectDetails": "Détails du projet",
    "editDetails": "Modifier les détails",
    "projectName": "Nom du projet",
    "projectNameHelperText": "24 caractères maximum",
    "projectLogoTitle": "Logo du projet",
    "projectLogoHint": "Cette image sera affichée dans la barre de navigation supérieure et sur la page de connexion du projet",
    "projectLogoRemoveTitle": "Supprimer l'image du logo de ce projet",
    "projectLogoRemoveText": "Cela supprimera le fichier image du logo et toutes les personnes ayant accès au projet ne le verront plus. Êtes-vous sûr de vouloir continuer ?",
    "projectLogoRestrictionHint": "La taille maximale de l'image est de 1920 pixels (hauteur) et 1080 pixels (largeur)",
    "projectImageTitle": "Image du projet",
    "projectImageHint": "Cette image sera affichée dans la carte du projet et le tableau de bord",
    "projectImageRemoveTitle": "Supprimer l'image de ce projet",
    "projectImageRemoveText": "Cela supprimera le fichier image et toutes les personnes ayant accès au projet ne le verront plus. Êtes-vous sûr de vouloir continuer ?",
    "projectImageRestrictionHint": "La taille maximale de l'image est de 1920 pixels (hauteur) et 1080 pixels (largeur)"
  },
  "scheduleConfig": {
    "title": "Configuration du calendrier",
    "description": "Le calendrier peut être configuré à l'aide des paramètres ci-dessous. N'apportez des modifications ici que si vous avez une compréhension détaillée du fonctionnement de la configuration du calendrier. En cas de doute, contactez le support Iventis :",
    "save": "Enregistrer les modifications d'horaire",
    "timesAndDates": "Horaires et dates",
    "venueTypeHierarchy": "Hiérarchie des types de lieux",
    "scheduleVersionHierarchy": "Hiérarchie des versions de planification",
    "eventBlockHierarchy": "Hiérarchie des blocs d'événements",
    "venueRunSheets": "Fiches de gestion des sites (DCAS)",
    "timezone": "Fuseau horaire",
    "dayStartTime": "Heure de début de chaque journée",
    "dayEndTime": "Heure de fin de chaque journée",
    "projectStartDate": "Date de début du projet",
    "projectEndDate": "Date de fin du projet",
    "projectZeroDate": "Jour 0 du projet",
    "eventBlockTitleTop": "Blocs d'événements de calendrier de haut niveau",
    "eventBlockTitleSecond": "Blocs d'événements de calendrier de deuxième niveau",
    "eventBlockTitleThird": "Bloc d'événements de calendrier de troisième niveau",
    "eventBlockTitleDefault": "Bloc d'événements Level Calendar",
    "eventBlockTypeName": "Nom du type de bloc d'événements",
    "eventBlockApiSingle": "Nom de l'API au singulier",
    "eventBlockApiPlural": "Nom de l'API au pluriel",
    "eventBlockAllowedVenueTypes": "Types de lieux autorisés",
    "eventBlockRelativeTypes": "Peut être relatif à des types",
    "eventBlockSummaryText": "Attributs du bloc d'événements pour enfants à utiliser dans le résumé",
    "eventBlockDCAS": "Peut être créé dans le DCAS",
    "eventBlockCustomerIdentifier": "Identifiant du client",
    "clusterVenueLocationTemplateTitle": "Modèle de localisation des sites du cluster",
    "mainVenueLocationTemplateTitle": "Modèle de localisation du lieu principal",
    "subVenueLocationTemplateTitle": "Modèle de localisation des sous-sites",
    "enableClusters": "Activer les clusters",
    "editVenues": "Modifier les lieux",
    "venueLocations": "Emplacements des salles",
    "venueLocationTypeName": "Nom du type de lieu",
    "attributes": "Attributs",
    "scheduleVersionTopLevelTitle": "Version du calendrier de haut niveau",
    "scheduleVersionSecondLevelTitle": "Version du calendrier de deuxième niveau",
    "scheduleVersionLevelTitle": "Version du calendrier des niveaux",
    "scheduleVersionName": "Nom de la version du calendrier",
    "problems": "Il y a {{ problemCount }} problèmes avec la configuration de planification soumise",
    "dcasEventBlock": "Bloc d'événements pour Run Sheet",
    "dcasEventBlockQuestion": "Activer le bloc d'événements uniquement sur la feuille de course",
    "dcasEventBlockCalendar": "Blocs d'événements à utiliser",
    "dcasEventBlockAttributes": "Attributs pour Run Sheet",
    "dcasEnableDone": "Marquer les activités avec « Terminé »",
    "calendarLevel": {
      "0": "session",
      "1": "élément programmé",
      "activity": "activité"
    }
  }
}